import { gql } from '@apollo/client';

export const FETCH_AUTH_DOMAIN_FEATURE_FLAGS = gql`
    query fetchAuthDomainFeatureFlags($authDomainFilter: AuthDomainFilter!, $featureFlagFilter: FeatureFlagFilter!) {
        system {
            authDomains(filter: $authDomainFilter) {
                companyAlias
                facilityAlias
                featureFlags(filter: $featureFlagFilter) {
                    key
                    isEnabled
                    owner {
                        companyAlias
                        facilityAlias
                    }
                }
            }
        }
    }
`;
